import { createFileRoute } from "@tanstack/react-router"

import PermissionContentWrapper from "@/components/PermissionWrapper/PermissionContentWrapper"
import { PermissionActionType } from "@/constants/permissions"
import ProductStorageContainer from "@/screens/Products/components/Product/Storage/components/ProductStorageContainer"

export const Route = createFileRoute("/app/product/$productId/edit/_layout/storage")({
  component: () => (
    <PermissionContentWrapper permissions={[PermissionActionType.WAREHOUSES_VIEW]}>
      <ProductStorageContainer />
    </PermissionContentWrapper>
  ),
})
